The date & time the job ad failed to be posted within SEEK's systems. This corresponds to the `Event.createDateTime` field in the GraphQL schema.
